import React from 'react';
import intro from '../../../../assets/conference/intro.mp4';

const IntroVideoSlide = ({ slide, slideKey, currentSlide, onSlideChange }) => {
    return (
        <div key={slideKey} className="h-full w-full bg-black flex items-center justify-center">
            <video
                src={intro}
                autoPlay
                playsInline
                onEnded={() => onSlideChange(currentSlide + 1)}
                className="w-full h-full object-cover"
            />
        </div>
    );
};

export default IntroVideoSlide;
